import { z } from 'zod';
import { es } from 'zod/locales';

/**
 * Global Zod configuration: Spanish default messages so schema-driven forms
 * produce actionable feedback without repeating messages in every schema.
 * Imported once from the app entry point.
 */
export function configureZod(): void {
  z.config(es());
}
